<template>
  <div class="app-simple-checkbox">
    <label>
      <input
        v-bind="{ ...ariaInputCustom }"
        :checked="checked"
        class="visually-hidden"
        type="checkbox"
        v-on="inputListeners"
      />
      <span class="app-simple-checkbox__icon">
        <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <rect class="icon__frame" x="0.5" y="0.5" width="19" height="19" rx="0.5" />
          <path
            class="icon__checked"
            d="M8.71676 12.5606L5.76923 9.21179C5.72795 9.16321 5.67858 9.12446 5.624 9.09781C5.56941 9.07115 5.5107 9.05712 5.4513 9.05653C5.39189 9.05594 5.33298 9.06881 5.27799 9.09439C5.22301 9.11996 5.17305 9.15773 5.13104 9.20549C5.08903 9.25324 5.05581 9.31003 5.03332 9.37254C5.01082 9.43505 4.9995 9.50202 5.00002 9.56956C5.00053 9.63709 5.01288 9.70384 5.03632 9.76589C5.05977 9.82794 5.09386 9.88407 5.13659 9.93099L8.71586 14L15.8744 5.86198C15.9559 5.76605 16.001 5.63757 16 5.50421C15.999 5.37085 15.9519 5.24328 15.869 5.14897C15.786 5.05467 15.6738 5.00118 15.5565 5.00002C15.4392 4.99886 15.3262 5.05013 15.2418 5.14278L8.71676 12.5606Z"
          />
        </svg>
      </span>
      <span class="app-simple-checkbox__label">
        <slot name="label" />
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AppSimpleCheckbox',
  inheritAttrs: false,
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    aria: {
      type: Object,
      default: () => {
        return { ariaInput: {}, ariaMsg: {} };
      },
    },
    checked: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ariaInputCustom() {
      return {
        ...this.aria.ariaInput,
        'aria-invalid': this.error ? true : null,
      };
    },
    inputListeners() {
      return {
        ...this.$listeners,
        change: (e) => {
          this.$emit('change', e.target.checked);
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-simple-checkbox {
  label {
    display: flex;
    gap: 16px;
    max-width: max-content;
    user-select: none;
    margin-bottom: 0;
  }

  &__icon {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      width: 20px;
      height: 20px;

      &__frame {
        fill: vars.$c-total-white;
        stroke: vars.$c-dark-5b;
      }
      &__checked {
        display: none;
        fill: vars.$c-dark-gray;
      }
    }
  }

  input[aria-invalid] + &__icon {
    .icon__frame {
      stroke: vars.$c-invalid !important;
    }
  }

  input:checked + &__icon {
    .icon__checked {
      display: inline;
    }
  }
  input:focus-visible + &__icon {
    .icon {
      outline: 1px solid vars.$c-dark-5b;
    }
  }
  input:checked:focus-visible + &__icon {
    .icon {
      outline: 1px solid vars.$c-gray-a2;
    }
  }

  &__label {
    flex: 1;
    padding-right: 15px;
    color: vars.$c-dark-gray;
    font-size: 16px;
    font-weight: 400;
    line-height: 40px;

    a {
      color: vars.$c-link-7b;
      text-decoration-thickness: 1px;
      text-underline-offset: 3px;
      text-decoration: underline;

      &:hover,
      &:focus {
        color: vars.$c-link-7b !important;
      }
    }
  }
}
</style>
